/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Device Base Modules (@accedo/xdk-base-modules) 4.2.8
* 
*******************************************************************************/
const HTML5PlayerExternalSubtitleConfig={type:"subtitle",importer:()=>import("./HTML5PlayerExternalSubtitle.js"),config:{location:"external"}};export default HTML5PlayerExternalSubtitleConfig;